import { Chip, Grid, SxProps, Theme } from '@mui/material';
import { AppContextProps } from '../../../libs/app-core/AppContext';
import { MessageDialog } from '../../../libs/app-core/dialogs/MessageDialog';
import { Toast } from '../../../libs/app-core/Toast';
import { ROUTE_common_quest } from '../../Routes';
import { Member } from '../../dao/Member';
import { UniAnswerDAO } from '../../dao/UniAnswerDAO';
import { UniFunc } from '../../dao/UniFunc';
import { OpenPageFrmSpwkQuest_HoChen_Async as NavigateTo_FrmSpwkQuestHoChen_Async } from '../FrmMemberLogin';
import { FrmCommonQuestProps } from '../FrmCommonQuest';

type Props = {
  ctx: AppContextProps
  member: Member;
  is_spwk: boolean;
  UniFuncListCache: UniFunc[];
  sx?: SxProps<Theme>;

}

const UcUniFuncPills = ({ ctx, member, is_spwk, UniFuncListCache, sx }: Props) => {

  let uni_func_guids = (is_spwk ? member.getSpwkUniFuncGuids() : member.getCommonUniFuncGuids());
  return (
    <Grid container spacing={1}>

      {(is_spwk === true ? render_Pill("ALL", "ALL", member.getSpwkUniFuncGuids()) : undefined)}

      {uni_func_guids.map((uni_func_guid) => {
        var find = UniFuncListCache.find(x => x.guid === uni_func_guid);

        if (find == null) {
          return render_Pill(uni_func_guid, "???", [],);
        } else {
          return render_Pill(uni_func_guid, find.func_code, [find.guid],);
        }

      })}
    </Grid>
  );

  function render_Pill(uni_func_guid: string, pill_text: string, uni_func_guids: string[]) {

    return (
      <Grid item key={uni_func_guid}>
        <Chip color="primary" variant="outlined" sx={{ cursor: 'pointer', backgroundColor: 'white', ...sx }}
          label={pill_text}
          onClick={async () => {
            if (uni_func_guids.length === 0) {
              return;
            }

            if (is_spwk) {
              if (uni_func_guid != null && uni_func_guid !== "ALL") {
                Toast.ShowWarning(ctx, "目前只能以 [ALL] 開啟!!!");
                return;
              }

              await NavigateTo_FrmSpwkQuestHoChen_Async(member.guid, pill_text, uni_func_guid, ctx);

            } else {
              if (uni_func_guids.length !== 1) {
                Toast.ShowWarning(ctx, "只能開啟單個問卷!!!")
                return;
              }

              const common_func_guid = uni_func_guids[0];
              const member_guid = member.guid;
              await NavigateTo_FrmCommonQuest_Async(ctx, member_guid, common_func_guid);
            }

          }
          }
        />
      </Grid>
    );
  }
}

export default UcUniFuncPills

/**
 * 開啟一般問卷: 指定受檢者 與 要開哪種一般問卷 => 找出來並以一般問卷編輯器開啟
 */
export async function NavigateTo_FrmCommonQuest_Async(ctx: AppContextProps, member_guid: string, common_func_guid: string) {

  let answer_list = await UniAnswerDAO.WS_Select_ByMemberGuid(member_guid);
  // 找出指定表單的答案卷
  answer_list = answer_list.filter(x => x.func_guid === common_func_guid);
  if (answer_list.length === 1) {
    let params: FrmCommonQuestProps = {
      answer_guid: answer_list[0].guid,
    };

    ctx.Navigate(ROUTE_common_quest.url, { state: params });

  } else if (answer_list.length === 0) {
    MessageDialog.Show(ctx, "尚未設定 Answer !");
  } else {
    MessageDialog.Show(ctx, "多於一個 Answer !?");
  }

}